// English strings (source language): the phone controller page (/remote).

const en = {
  title: 'Phone controller',
  enterTitle: 'Your phone is the controller',
  enterText: 'Type the code shown on your computer, in Settings › Devices › Your phone.',
  codeLabel: 'Pairing code',
  connect: 'Connect',
  noApp: 'No app to install. Keep this page open while you ride.',
  connecting: 'Connecting…',
  reconnecting: 'Reconnecting…',
  hostOf: (name: string) => `${name}’s computer`,
  hostAway: 'Computer reconnecting…',
  layouts: { idle: 'Waiting for a ride', race: 'Race', workout: 'Workout', game: 'Game' },
  idleHint: 'Start a ride on your computer. Meanwhile, press a button: your computer shows it.',
  fullscreen: 'Full screen',
  unpair: 'Unpair this phone',
  again: 'Pair again',
  ended: {
    invalid: { title: 'Code not recognised', text: 'It may have expired or been used already. Ask your computer for a new code.' },
    busy: { title: 'Too many attempts', text: 'Too many wrong codes were typed just now. Scan the QR code instead, or try again in a minute.' },
    closed: { title: 'Pairing ended', text: 'Your computer closed the pairing.' },
    replaced: { title: 'Another phone took over', text: 'Only one phone controls a computer at a time.' },
    left: { title: 'Phone unpaired', text: 'This phone no longer controls your ride.' },
  },
};
export default en;
